import { render, staticRenderFns } from "./advertisementMask.vue?vue&type=template&id=46291425&scoped=true"
import script from "./advertisementMask.vue?vue&type=script&lang=js"
export * from "./advertisementMask.vue?vue&type=script&lang=js"
import style0 from "./advertisementMask.vue?vue&type=style&index=0&id=46291425&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46291425",
  null
  
)

export default component.exports